import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";
import Header from "components/UpdateUi/Header/Header";
import Footer from "components/UpdateUi/Footer/Footer";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";


let ps;

const useStyles = makeStyles(styles);

export default function Admin({ ...rest }) {
  // styles
  const classes = useStyles();
  const { authToken } = useSelector((state) => state.login.authData);
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const [color, setColor] = useState("blue");
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [outletData, setOutletData] = useState({});

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
useEffect(()=>{
  getUserDetails()
},[authToken])


  const getUserDetails = async () => {
    const result = await apiHandler({
      url: endpoint.USER_DETAIL,
      authToken: authToken,
    });
     setOutletData(result?.data)
  };

  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    } else {
      // setShowSidebar(true);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
      <div className={classes.mainPanel} ref={mainPanel}>
        <Header handleDrawerToggle={handleDrawerToggle} userDetailData={outletData}/>
        <div style={{ display: "flex" }}>
          <div className={classes.content}>
            <div className={classes.container}>
            <Outlet context={outletData} />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
